// extracted by mini-css-extract-plugin
export default {"inputRow":"widgetRowStyling_inputRow__Ym3T-"};